<div class="px-4 mb-4 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <span class="pt-5 col-12" translate="Settings.OrganisationBrandingSection.BrandingColours.Options"></span>
    <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
        <div class="d-table form-check form-switch col-10 pt-1">
            <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="useEmailLowSigning" name="useEmailLowSigning" [checked]="true" disabled>
            <label class="form-check-label pt-1 col-10" for="useEmailLowSigning" translate="Settings.OrganisationCreditsSection.ReminderLowSigningValue">
            </label>
        </div>
        <div ngbDropdown class="dropdown float-end col-2" ngDefaultControl>
            <button class="dropdown-toggle btn btn-sm form-control text-truncate default float-end" type="button" id="dropdownMenu" ngbDropdownToggle>
                {{organisationSettings.EmailLowSigningValueReminderSchedule}} %<em class="bi bi-chevron-down float-end ms-2" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <button *ngFor="let percentage of lowSigningPercentage" [value]="percentage" id="EmailLowSigningValueReminderSchedule" (click)="updateValue($event)" ngbDropdownItem>{{percentage}} %</button>
            </div>
        </div>
    </div>
</div>